module.exports = __webpack_public_path__ + "img/Yos_Adiguna_GintingB.ed76663b.jpg";